import { render, staticRenderFns } from "./PartsRequest.vue?vue&type=template&id=38aba5c7&scoped=true&"
import script from "./PartsRequest.vue?vue&type=script&lang=js&"
export * from "./PartsRequest.vue?vue&type=script&lang=js&"
import style0 from "./PartsRequest.vue?vue&type=style&index=0&id=38aba5c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aba5c7",
  null
  
)

export default component.exports